// TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
import React, { useState, useEffect } from 'react';
import { t } from 'Locale';
import { View } from 'react-native';
import { Device } from 'DeviceUtils';
import { Icon, CustomNavTitle } from 'LocalGluons';

import EPGDatePickToggler from 'LocalGluons/components/EpgContainer/components/DatePickToggler';
import EPGFilterToggler from 'LocalGluons/components/EpgContainer/components/FilterToggler';
import EpgBackHandler from 'LocalGluons/components/EpgContainer/components/EpgBackHandler';
import Player from 'LocalGluons/components/Player';
import {
    ViewAll,
    Details,
    TvGuide,
    Register,
    Search,
    Showtimes,
    DeviceManagement,
    NetworkSettings,
    LanguageSettings,
    Parental,
    VideoQualitySettings,
    PackageFavorite,
    FavoritesSettings,
    AppInfo,
    ClearCache,
    AccountInfo,
    ConsentsDetailed
} from 'Pages';
import { favoritesSettingsNavigationOptions } from 'Pages/FavoriteSettings';
import { TabsNavigatorWithIPTV, TabsNavigator } from 'Pages/Recordings/RecordingTabs';
import {
    CanalPlusAboutService,
    CanalplusConsentDialog
} from 'LocalGluons/components/CanalplusConsentDialog';
import { IconBack, iconPlaceholder, iconSearch, IconBackWithText } from './navigationHeaderIcons';
import { headerTitleStyle, navigationStyles } from './navigationOptions';
import styles from './navigationHeaderIcons.jss';
import { useNavigationPropsContext } from './navigationPropsContext';

// Must be function because of translations
export const GetAppRouteConfigMap = () => ({
    Search: {
        screen: Search,
        navigationOptions: ({ navigation }) => {
            const { navigationProps } = useNavigationPropsContext();
            const count = navigationProps?.itemsHeaderCount || 0;
            const secondaryText = count > 0 ? ` (${count})` : null;
            return Device.isWeb
                ? {
                      headerShown: false
                  }
                : {
                      animation: !Device.isWeb ? 'fade_from_bottom' : 'none',
                      headerLeft: () => {
                          const [isfromSearchData, setIsFromSearchData] = useState(null);
                          const [fromSearchData, setFromSearchData] = useState(null);
                          const navData = navigation.getState();

                          useEffect(() => {
                              setIsFromSearchData(
                                  navData.routes[navData.routes.length - 1]?.params?.queryScope
                              );
                              setFromSearchData(
                                  navData.routes[navData.routes.length - 1]?.params?.query
                              );
                          }, [navData]);
                          return (
                              <IconBack
                                  onPress={() => {
                                      if (isfromSearchData === 'CAST') {
                                          navigation.goBack();
                                          navigation.navigate('Search', {
                                              showSearchBox: true,
                                              queryScope:
                                                  navData.routes[navData.routes.length - 1]?.params
                                                      ?.previousQueryScope || 'ALL',
                                              query:
                                                  navData.routes[navData.routes.length - 1]?.params
                                                      ?.previousQuery || fromSearchData
                                          });
                                      } else {
                                          navigation.goBack();
                                      }
                                  }}
                              />
                          );
                      },
                      headerTitle: () => (
                          <CustomNavTitle
                              primaryText={t('COMMON.SEARCH').toUpperCase()}
                              secondaryText={secondaryText}
                          />
                      ),
                      headerRight: () => iconPlaceholder
                  };
        }
    },
    Player: {
        requiresLogin: true,
        screen: Player,
        navigationOptions: {
            headerShown: false
        }
    },
    Showtimes: {
        screen: Showtimes,
        navigationOptions: {
            headerTitle: t('COMMON.SHOWTIMES').toUpperCase(),
            headerLeft: IconBack,
            headerRight: () => iconPlaceholder
        }
    },
    TvGuide: {
        screen: TvGuide,
        navigationOptions: ({ route }) => {
            const filterActive = route.params?.filterActive || false;
            return Device.isWeb
                ? {
                      headerShown: false
                  }
                : {
                      headerTitle: () => <EPGDatePickToggler />,
                      headerRight: () => (
                          <View style={{ flexDirection: 'row' }}>
                              {!Device.isTablet && (
                                  <EPGFilterToggler testID="filter_button" active={filterActive} />
                              )}
                              {iconSearch}
                          </View>
                      ),
                      headerLeft: () => <EpgBackHandler />
                  };
        }
    },
    ViewAll: {
        screen: ViewAll,
        animation: !Device.isWeb ? 'fade_from_bottom' : 'none',
        navigationOptions: ({ route }) => {
            const { navigationProps } = useNavigationPropsContext();
            const { title } = navigationProps;
            return {
                headerRight: () => (Device.isWeb ? null : iconSearch),
                headerTitle: title || t('COMMON.VIEW_ALL'),
                headerLeft: Device.isTabletOrWeb ? () => <IconBackWithText /> : IconBack
            };
        }
    },
    Details: {
        screen: Details,
        navigationOptions: (p) => ({
            headerRight: () => (Device.isWeb ? null : iconSearch),
            headerLeft: Device.isTabletOrWeb ? () => <IconBackWithText /> : IconBack,
            headerTitle: Details.DetailsHeaderTitle,
            animation: !Device.isWeb ? 'fade_from_bottom' : 'none'
        })
    },
    Register: {
        screen: Register,
        navigationOptions: {
            headerTitle: t('COMMON.START_WITH_MAGIO'),
            headerLeft: IconBack,
            headerRight: () => iconPlaceholder
        }
    },
    SettingsParental: {
        requiresLogin: true,
        screen: Parental,
        navigationOptions: {
            headerTitle: t('SETTINGS.PARENTAL_CONTROL'),
            headerLeft: IconBack,
            headerRight: () => iconPlaceholder,
            headerTitleAlign: 'center',
            headerTitleStyle: navigationStyles.headerTitleStyleNormalWeight,
            animation: !Device.isWeb ? 'slide_from_right' : 'none'
        }
    },
    DeviceManagement: {
        requiresLogin: true,
        screen: DeviceManagement,
        navigationOptions: {
            headerTitle: t('SETTINGS.DEVICES'),
            headerLeft: IconBack,
            headerRight: () => iconPlaceholder,
            headerTitleStyle: navigationStyles.headerTitleStyleNormalWeight,
            animation: !Device.isWeb ? 'slide_from_right' : 'none'
        }
    },
    NetworkSettings: {
        requiresLogin: true,
        screen: NetworkSettings,
        navigationOptions: {
            headerTitle: t('SETTINGS.NETWORK'),
            headerLeft: IconBack,
            headerRight: () => iconPlaceholder,
            headerTitleAlign: 'center',
            headerTitleStyle: navigationStyles.headerTitleStyleNormalWeight,
            animation: !Device.isWeb ? 'slide_from_right' : 'none'
        }
    },
    LanguageSettings: {
        requiresLogin: false,
        screen: LanguageSettings,
        navigationOptions: {
            headerTitle: t('SETTINGS.LANGUAGE'),
            headerLeft: IconBack,
            headerRight: () => iconPlaceholder,
            headerTitleAlign: 'center',
            headerTitleStyle: navigationStyles.headerTitleStyleNormalWeight,
            animation: !Device.isWeb ? 'slide_from_right' : 'none'
        }
    },
    VideoQualitySettings: {
        requiresLogin: true,
        screen: VideoQualitySettings,
        navigationOptions: {
            // temporairy disable data saver
            headerTitle: t('SETTINGS.DATA_SAVER.MENU_ITEM'),
            headerLeft: IconBack,
            headerRight: () => iconPlaceholder,
            headerTitleAlign: 'center',
            headerTitleStyle: navigationStyles.headerTitleStyleNormalWeight,
            animation: !Device.isWeb ? 'slide_from_right' : 'none'
        }
    },
    FavoriteSettings: {
        requiresLogin: true,
        screen: FavoritesSettings,
        navigationOptions: favoritesSettingsNavigationOptions
    },
    PackageFavorite: {
        requiresLogin: true,
        screen: PackageFavorite,
        navigationOptions: ({ route }) => {
            const activeCategory = route?.params?.activeCategory || { title: 'Package' };
            return {
                headerTitle: activeCategory?.title,
                headerLeft: IconBack,
                headerRight: () => iconPlaceholder,
                headerTitleStyle: navigationStyles.headerTitleStyleNormalWeight
            };
        }
    },
    RecordingsAll: {
        requiresLogin: true,
        screen: TabsNavigator,
        navigationOptions: {
            headerTitle: t('RECORDINGS.RECORDINGS_TITLE').toUpperCase(),
            headerLeft: Device.isTabletOrWeb ? () => <IconBackWithText /> : IconBack,
            headerRight: () => (Device.isWeb ? undefined : iconSearch)
        }
    },
    RecordingsAllIPTV: {
        requiresLogin: true,
        screen: TabsNavigatorWithIPTV,
        navigationOptions: {
            headerTitle: t('RECORDINGS.RECORDINGS_TITLE').toUpperCase(),
            headerLeft: Device.isTabletOrWeb ? () => IconBackWithText() : IconBack,
            headerRight: () => (Device.isWeb ? undefined : iconSearch)
        }
    },
    AppInfo: {
        screen: AppInfo,
        navigationOptions: {
            headerTitle: t('SETTINGS.APP_INFO'),
            headerTitleAlign: 'center',
            headerLeft: IconBack,
            animation: !Device.isWeb ? 'slide_from_right' : 'none'
        }
    },
    ClearCache: {
        screen: ClearCache,
        navigationOptions: Device.isTabletOrWeb
            ? {
                  headerTitle: t('COMMON.CLEAR_CACHE'),
                  headerLeft: IconBack,
                  animation: !Device.isWeb ? 'slide_from_right' : 'none'
              }
            : {
                  header: () => null,
                  animation: !Device.isWeb ? 'slide_from_right' : 'none'
              }
    },
    AccountInfo: {
        requiresLogin: true,
        screen: AccountInfo,
        navigationOptions: {
            headerTitle: t('COMMON.ACCOUNT_INFO'),
            headerLeft: IconBack,
            headerRight: () => iconPlaceholder,
            headerTitleAlign: 'center',
            headerTitleStyle: navigationStyles.headerTitleStyleNormalWeight,
            animation: !Device.isWeb ? 'slide_from_right' : 'none'
        }
    },
    NativeConsents: {
        screen: ConsentsDetailed,
        navigationOptions: ({ navigation, route }) => ({
            headerTitle: t('SETTINGS.CONSENTS_MENU_ITEM_MOBILES'),
            headerLeft: () => {
                const setShowConsentsAgain = route.params?.setShowConsentsAgain || false;
                return setShowConsentsAgain ? (
                    <Icon
                        style={styles.backIcon}
                        onPress={() => {
                            setShowConsentsAgain(true);
                            navigation.navigate('home');
                        }}
                        name="arrow_left"
                        key="arrow_left"
                        testID="back_button"
                    />
                ) : (
                    <IconBack
                        onPress={() => {
                            navigation.goBack();
                        }}
                    />
                );
            },
            headerRight: () => iconPlaceholder,
            headerTitleAlign: 'center',
            headerTitleStyle: navigationStyles.headerTitleStyleNormalWeight,
            animation: !Device.isWeb ? 'slide_from_right' : 'none'
        })
    },
    CanalplusAboutService: {
        requiresLogin: true,
        screen: CanalPlusAboutService,
        navigationOptions: ({ navigation, route }) => ({
            headerTitleStyle: navigationStyles.headerTitleStyleNormalWeight,
            headerLeft: () => <IconBack onPress={() => navigation.pop()} />,
            headerRight: () => iconPlaceholder,
            headerTitle: t('PARTNER.CANALPLUS.VOD_LABEL')
        })
    },
    CanalplusConsent: {
        requiresLogin: true,
        screen: CanalplusConsentDialog,
        navigationOptions: ({ navigation, route }) => ({
            headerTitle: t('PARTNER.CANALPLUS.CONSENTS.MENU_ITEM_MOBILES'),
            headerLeft: () => {
                const setShowConsentsAgain = route.params?.setShowConsentsAgain || false;
                return setShowConsentsAgain ? (
                    <Icon
                        style={styles.backIcon}
                        onPress={() => {
                            setShowConsentsAgain(true);
                            navigation.goBack();
                        }}
                        name="arrow_left"
                        key="arrow_left"
                        testID="back_button"
                    />
                ) : (
                    <IconBack />
                );
            },
            headerRight: () => iconPlaceholder,
            // headerTitleAlign: 'center',
            headerTitleStyle: navigationStyles.headerTitleStyleNormalWeight
        })
    }
});
